const Badge = ({ count, className = "", children }) => {
  return (
    <div className={`relative inline-flex ${className}`}>
      {children}
      <span className="absolute -top-1 -right-1 flex h-4 w-4 items-center justify-center rounded-full bg-red-500 text-[10px] font-bold text-white ring-2 ring-white">{count > 99 ? "99+" : count}</span>
    </div>
  )
}

export default Badge